// extracted by mini-css-extract-plugin
export var actionIcon = "_so-0";